import React, { useState } from 'react';
import { Button } from 'reactstrap';
import AddNewProduct from './AddNewProduct';

export default function ProductFormButton({
    id,
    LoadData
}) {
    const [isUpdating, setIsUpdating] = useState(false);

    return (
        <div>
            <Button
                color="primary"
                size="sm"
                onClick={() => setIsUpdating(!isUpdating)}
            >
                Edit
      </Button>
            {isUpdating && (
                <AddNewProduct
                    id={id}
                    toggleModal={() => {
                        setIsUpdating(!isUpdating);
                    }}
                    formLabel="Edit Product"
                    visible={isUpdating}
                    LoadData={LoadData}
                />
            )}
        </div>
    );
}

